function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.296.5a.584.584 0 00-.085.008H2.14A2.147 2.147 0 000 2.645v9.71c0 1.174.965 2.137 2.139 2.137h.682c.063.01.126.01.19 0h7.977c.062.01.126.01.189 0h.684A2.147 2.147 0 0014 12.356V4.199a.581.581 0 00-.196-.436l-3.5-3.107a.584.584 0 00-.387-.148h-.294a.584.584 0 00-.189 0H3.401A.584.584 0 003.296.5zM2.14 1.674h.583V3.81c0 .744.617 1.36 1.361 1.36H8.75a1.37 1.37 0 001.361-1.36V2.043l2.722 2.417v7.896a.963.963 0 01-.972.971h-.194V8.86a1.37 1.37 0 00-1.361-1.36H3.694a1.37 1.37 0 00-1.36 1.36v4.467h-.195a.963.963 0 01-.972-.971V2.645c0-.543.428-.971.972-.971zm1.75 0h5.055V3.81c0 .115-.08.194-.194.194H4.083a.186.186 0 01-.194-.194V1.674zm-.195 6.992h6.612c.114 0 .194.08.194.194v4.467h-7V8.86c0-.115.08-.194.194-.194z",
  fill: "#6264A7"
});

function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSave;